
export const translations = {
  es: {
    seo: {
      title: "Negolan - Innovación, Exclusividad y Oportunidad",
      description: "Plataforma de Universal Tecno Services dedicada a la incubación y aceleración de proyectos tecnológicos disruptivos desde Houston, Londres, Barcelona y Andorra.",
      keywords: "Negolan, Tecnología, Innovación, Inversión, Proyectos Tecnológicos, Houston, Londres, Barcelona, Andorra, Universal Tecno Services"
    },
    translationWarning: "",
    header: {
      about: "Sobre Nosotros",
      careers: "Trabaja con Nosotros",
      investors: "Inversores",
      projects: "Proyectos",
      adminPanel: "Panel de Control",
      logout: "Cerrar Sesión",
      login: "Acceder",
      weLoveAndorra: "We ❤️ Andorra",
    },
    hero: {
      titlePre: "Siempre Buscando",
      titleInventors: "Inventor@s",
      titleAnd: "e",
      titleInvestors: "Inversor@s",
      subtitle: "Innovación, exclusividad y oportunidad. Descubra los proyectos tecnológicos que están definiendo el futuro desde Houston, Londres, Barcelona y Andorra.",
      buttonProjects: "Ver Proyectos",
      buttonJoin: "Únete a Nosotros",
      buttonInvest: "Quiero Invertir",
    },
    about: {
      title: "Nuestra Misión",
      subtitle: "Conectamos visión con capital, y talento con oportunidad.",
      card1Title: "Sobre Negolan",
      card1Text: "Negolan es la plataforma de Universal Tecno Services dedicada a la incubación y aceleración de proyectos tecnológicos disruptivos. Nuestro enfoque es dual: por un lado, ofrecemos una ventana exclusiva a nuestros socios e inversores para que sigan de cerca el progreso de nuestras iniciativas; por otro, buscamos activamente a los profesionales más brillantes para que se unan a nuestros equipos y nos ayuden a construir el futuro.",
      card2Title: "Universal Tecno Services",
      card2Text: "Como empresa matriz, Universal Tecno Services provee la infraestructura, el respaldo estratégico y la visión a largo plazo. Creemos en la tecnología como motor de cambio y progreso. Operamos globalmente desde centros neurálgicos de innovación como Houston, Londres, Barcelona y Andorra, impulsando soluciones que abarcan desde las telecomunicaciones hasta la seguridad financiera y la energía sostenible.",
    },
    careers: {
      title: "Trabaja con Nosotros",
      subtitle: "Buscamos mentes innovadoras y apasionadas. La mayoría de nuestros roles son en remoto. ¿Estás listo para el reto?",
      applyNow: "Aplicar Ahora",
      noJobs: "Actualmente no hay ofertas de trabajo disponibles. Vuelve a consultar más adelante.",
    },
    investors: {
      title: "Oportunidades de Inversión",
      subtitle: "En Negolan, ofrecemos acceso exclusivo a un portafolio de proyectos tecnológicos con alto potencial de crecimiento. Buscamos socios estratégicos que compartan nuestra visión y deseen formar parte de la próxima generación de innovación.",
      listItem1: "Acceso a información privilegiada y reportes de progreso detallados.",
      listItem2: "Diversificación en sectores de vanguardia: Fintech, IoT, Energía y Telecom.",
      listItem3: "Oportunidades de co-inversión y participación en rondas de financiación.",
      formTitle: "Contacte con nuestro equipo especial para inversores",
      formName: "Nombre Completo",
      formEmail: "Email Corporativo",
      formCompany: "Empresa o Fondo de Inversión",
      formMessage: "Su mensaje (opcional)",
      formButton: "Solicitar Información",
      thankYouTitle: "Gracias por su interés",
      thankYouText: "Nuestro equipo de relaciones con inversores se pondrá en contacto con usted en breve.",
      thankYouButton: "Enviar otra respuesta",
    },
    footer: {
      copy: "Negolan - Universal Tecno Services. Todos los derechos reservados.",
      confidentiality: "La información sobre proyectos es confidencial. El acceso y uso están sujetos a un acuerdo de confidencialidad.",
      legalNotice: "Aviso Legal",
      privacyPolicy: "Política de Privacidad",
      cookiesPolicy: "Cookies",
      termsOfService: "Términos de Servicio",
      credits: "Web creada por LumInA Genesis y Genara Perez Toledo de Negolan.com",
      errorLinkPlaceholder: "Has encontrado algun error en nuestra web, por favor dinoslo pulsando este link"
    },
    errorModal: {
      title: "Informar de un error",
      name: "Nombre",
      email: "Correo electrónico",
      description: "Explique el problema (máx. 2000 caracteres)",
      submit: "Enviar reporte",
      subject: "Reporte de error en la web de Negolan"
    },
    projectsModal: {
      title: "Nuestros Proyectos",
      partnershipAvailable: "Disponible Partnership",
      confidentialDetails: "Detalles Confidenciales",
      progress: "Progreso",
      confidentialInfoTitle: "Información Confidencial",
      confidentialInfoText: "Inicie sesión para ver los detalles.",
      loginButton: "Acceder",
    },
    loginModal: {
      title: "Acceso a Proyectos",
      subtitle: "Introduzca sus credenciales para continuar.",
      emailPlaceholder: "Email",
      passwordPlaceholder: "Contraseña",
      loginButton: "Acceder",
      termsPrefix: "Al acceder, usted acepta nuestro",
      termsNDA: "acuerdo de confidencialidad",
      termsAnd: "y los",
      termsService: "términos de servicio",
      loginError: "Datos de Acceso Erroneos. Contacte con nosotros a traves del boton de Whatsapp Business que se encuentra en todas nuestras paginas.",
    },
    clientArea: {
      welcome: "Hola,",
      subtitle: "Bienvenido a tu área exclusiva. Aquí tienes acceso a los proyectos de Negolan asignados a tu cuenta.",
      logout: "Cerrar Sesión",
      confidentialDetails: "Ver Detalles Confidenciales",
      investmentOpportunity: "Oportunidad de Inversión",
      noProjects: "No tienes proyectos asignados actualmente.",
      supportTitle: "¿Necesitas soporte técnico?",
      supportText: "Si tienes dudas sobre tus proyectos o necesitas ayuda técnica con la plataforma, nuestro equipo está a tu disposición.",
      supportButton: "Contactar Soporte",
      guideButton: "Guía del Cliente",
    },
    adminPanel: {
        title: "Panel de Control",
        closeButton: "Cerrar Panel",
        navProjects: "Proyectos",
        navJobs: "Empleo",
        navInvestors: "Inversores",
        navPartnerships: "Partnerships",
        manageProjectsTitle: "Gestionar Proyectos",
        addProjectButton: "Añadir Proyecto",
        edit: "Editar",
        delete: "Eliminar",
        pause: "Pausar",
        resume: "Reanudar",
        confirmDeleteProject: "¿Seguro que quieres eliminar este proyecto?",
        projectFormEditTitle: "Editar Proyecto",
        projectFormAddTitle: "Añadir Proyecto",
        projectFormName: "Nombre del Proyecto (siempre en español)",
        projectFormCityES: "Ciudad (ES)",
        projectFormCityEN: "City (EN)",
        projectFormAreaES: "Área (ES)",
        projectFormAreaEN: "Area (EN)",
        projectFormDescES: "Descripción Pública (ES)",
        projectFormDescEN: "Public Description (EN)",
        projectFormIconURL: "URL del Logo",
        projectFormPartnership: "Disponible para Partnership",
        cancel: "Cancelar",
        save: "Guardar",
        manageJobsTitle: "Gestionar Ofertas",
        addJobButton: "Añadir Oferta",
        confirmDeleteJob: "¿Seguro que quieres eliminar esta oferta de trabajo?",
        jobFormEditTitle: "Editar Oferta",
        jobFormAddTitle: "Añadir Oferta",
        jobFormTitleES: "Título de la oferta (ES)",
        jobFormTitleEN: "Job Title (EN)",
        jobFormLocationES: "Ubicación (ES)",
        jobFormLocationEN: "Location (EN)",
        jobFormTypeES: "Tipo de contrato (ES)",
        jobFormTypeEN: "Contract Type (EN)",
        jobFormDescES: "Descripción (ES)",
        jobFormDescEN: "Description (EN)",
        investorLeadsTitle: "Investor Leads",
        addLeadButton: "Añadir Lead",
        noInvestorLeads: "No hay leads de inversores por el momento.",
        leadFormTitle: "Añadir Lead Manualmente",
        leadFormName: "Nombre Completo",
        leadFormEmail: "Email",
        leadFormCompany: "Empresa (Opcional)",
        leadFormMessage: "Mensaje (Opcional)",
        saveLeadButton: "Guardar Lead",
        partnershipLeadsTitle: "Leads de Partnership",
        noPartnershipLeads: "No hay leads de partnership por el momento.",
        interestProject: "Proyecto de Interés",
        collaborationType: "Tipo de Colaboración",
        budget: "Inversión/Presupuesto",
        companyDescription: "Descripción de la Empresa",
        detailedProposal: "Propuesta Detallada",
        ndaAccepted: "NDA Aceptado",
        yes: "Sí",
        no: "No",
    },
    maintenance: {
        title: "Sitio en Mantenimiento",
        subtitle1: "Estamos realizando importantes mejoras en nuestra plataforma.",
        subtitle2: "Volveremos a estar operativos mañana. Disculpen las molestias.",
    },
    partnershipPage: {
        title: "Oportunidades de Partnership",
        intro: "En Negolan, creemos en el poder de la colaboración para impulsar la innovación. Estamos buscando socios estratégicos que compartan nuestra visión \"traviesa\" de la tecnología y nuestro deseo de construir soluciones de IA que rompan esquemas.",
        whatWeOfferTitle: "¿Qué ofrece Negolan?",
        offer1: "Infraestructura Legal (Empresas, Abogados, Procuradores, Notarios, etc...) --> Todo lo que hace falta para funcionar legalmente desde paises mas alla de España.",
        offer2: "Medios Tecnicos (Hosting, Dominios, Servidores, Know-How, Experiencia Elevada, Cloud, etc...) --> Todo lo que hace falta para funcionar tecnicamente.",
        offer3: "Contabilidad (Internacional)",
        outro: "Basicamente, aqui esta explicado con otras palabras:",
        feature1Title: "1. Protección Anti-Censura Avanzada",
        feature1Text: "Red de escape digital: despliegue automático de clones y espejos en países “refugio”, con cambio de DNS y backup instantáneo si hay bloqueos. Sistema de alerta temprana: notifica al cliente si hay riesgo de censura o acceso restringido en algún país. VPN o proxy integrado para creadores y empresas, con rutas inteligentes.",
        feature2Title: "2. Identidad Digital Blindada",
        feature2Text: "Creación y gestión de identidades digitales protegidas, incluso con representación legal en países “amigos”. Cuentas multi-país para recibir pagos y operar con seguridad jurídica real, no solo la promesa de Stripe.",
        feature3Title: "3. Certificación y Timestamping en Blockchain",
        feature3Text: "Prueba de autoría y existencia para contenidos, contratos, diseños, ideas... “Digital notary” services with an immutable timestamp and verification on multiple public chains.",
        feature4Title: "4. Defensa y Auditoría Anti-Estafas",
        feature4Text: "Auditoría de proyectos y contratos (por IA y humanos) para detectar trampas, cláusulas abusivas o scam. Lista negra colaborativa y sistema de alertas para inversores y programadores.",
        feature5Title: "5. Bóveda Digital Secreta",
        feature5Text: "Almacenamiento cifrado tipo “caja fuerte digital” para documentos, claves, backups críticos... Recuperación solo mediante procedimientos jurídicos o delegados (evitando el típico “perdí la contraseña y me arruiné”).",
        feature6Title: "6. Asistencia Legal y Fiscal 24/7 con IA + Humanos",
        feature6Text: "Asistente jurídico entrenado en varias jurisdicciones, que resuelve dudas básicas en tiempo real y deriva a humano solo si hace falta. Alerta de cambios normativos (¡imagina que te avise antes de que cambien la ley fiscal en Estonia o el régimen de criptos en Portugal!).",
        feature7Title: "7. Free Talent Marketplace",
        feature7Text: "Una bolsa de programadores y especialistas “certificados” por Negolan, que además pueden proteger su trabajo bajo contratos inteligentes con pago garantizado por milestone. Opción de “rescate exprés”: si un programador se ve en apuros, puede solicitar mediación y protección directa (incluso fisica).",
        feature8Title: "8. Escudo contra el Acoso Digital",
        feature8Text: "Defensa anti doxxing y amenazas: servicios para proteger la identidad y la seguridad de los clientes cuando los gigantes (or los trolls) se ponen pesados. Asistencia inmediata para presentar denuncias, borrar información expuesta, o neutralizar ataques reputacionales.",
        feature9Title: "9. Formación Ultra-Realista",
        feature9Text: "Mini-cursos y bootcamps para fundadores, inversores y programadores: cómo moverse por la jungla digital, esquivar fraudes, optimizar fiscalidad, y usar IA sin que te explote en la cara. Laboratorio de pruebas para experimentar con tecnologías nuevas sin riesgo.",
        feature10Title: "10. Sistema de Reputación Digital",
        feature10Text: "Basado en blockchain y validado por clientes reales, no reviews de coleguitas. A mayor reputación, mejores condiciones y acceso a recursos premium.",
        feature11Title: "11. Red de Apoyo Personal y “Desahogo”",
        feature11Text: "Espacios privados para compartir problemas, estafas sufridas, acosos, fracasos… con anonimato garantizado y posibilidad de ayuda legal/psicológica.",
        feature12Title: "12. Burocracia Asistida “Cero-papeles”",
        feature12Text: "Herramientas automáticas para presentar escritos legales, reclamaciones, registros de marca/patente y trámites internacionales… sin sudar ni una gota.",
        feature13Title: "13. IA “Bofetón Legal”",
        feature13Text: "Asistente que genera respuestas legales mordaces, con base en la normativa de cada país, para contestar a bancos, multinacionales, administraciones o cualquier abusón.",
        callToAction: "Si representas a una empresa o eres un inversor con una idea audaz y buscas un equipo técnico capaz de llevarla a la realidad, has llegado al lugar correcto. Nos especializamos en convertir conceptos ambiciosos en productos funcionales y disruptivos. Rellena el siguiente formulario para iniciar la conversación. Queremos conocer todos los detalles de tu propuesta.",
        formTitle: "Formulario de Propuesta de Partnership",
        submittedTitle: "Propuesta Enviada con Éxito",
        submittedText: "Gracias por tu interés en colaborar. Hemos recibido tu propuesta y nuestro equipo la revisará detenidamente.",
        submittedSubtext: "Nos pondremos en contacto contigo en breve.",
        backButton: "Volver a la web",
        projectInterestLabel: "Proyecto de Interés",
        collaborationTypeLabel: "Tipo de Colaboración Propuesta",
        collaborationTypePlaceholder: "Selecciona un tipo...",
        collabOptionFinancial: "Inversión Financiera",
        collabOptionTech: "Tecnológica",
        collabOptionMarketing: "Marketing y Ventas",
        collabOptionStrategic: "Alianza Estratégica",
        collabOptionRnD: "Investigación y Desarrollo",
        collabOptionOther: "Otra",
        companyNameLabel: "Nombre de la Empresa/Organización",
        companyNamePlaceholder: "Tu empresa S.L.",
        contactPersonLabel: "Nombre de la Persona de Contacto",
        contactPersonPlaceholder: "Juan Pérez",
        emailLabel: "Email de Contacto",
        emailPlaceholder: "juan.perez@tuempresa.com",
        countryLabel: "País",
        sortBy: "Ordenar por:",
        sortByName: "Nombre",
        sortByCode: "Código",
        sortByPrefix: "Prefijo",
        phoneLabel: "Número de Teléfono (Opcional)",
        phonePlaceholder: "123 456 789",
        websiteLabel: "Sitio Web de la Empresa (Opcional)",
        websitePlaceholder: "https://tuempresa.com",
        companyDescLabel: "Breve Descripción de tu Empresa",
        companyDescPlaceholder: "Describe la actividad principal, tamaño y mercado de tu empresa.",
        proposalLabel: "Propuesta Detallada de Partnership",
        proposalPlaceholder: "Explica tu idea, los objetivos, qué aportas y qué esperas de nosotros. Sé lo más detallado posible.",
        budgetLabel: "Presupuesto o Inversión Estimada (Opcional)",
        budgetPlaceholder: "Ej: '€50,000' o 'Participación del 20%'",
        securityQuestionLabel: "Pregunta de Seguridad",
        securityQuestionText: "¿Cuánto es {num1} + {num2}?",
        securityAnswerPlaceholder: "Tu respuesta",
        ndaLabel: "Acepto que la información compartida es confidencial y estoy dispuesto/a a firmar un NDA si es necesario.",
        submitButton: "Enviar Propuesta",
        alertIncorrectAnswer: "Respuesta de seguridad incorrecta.",
        alertNdaRequired: "Debe aceptar el acuerdo de confidencialidad.",
    },
  },
  en: {
    seo: {
      title: "Negolan - Innovation, Exclusivity and Opportunity",
      description: "Universal Tecno Services platform dedicated to the incubation and acceleration of disruptive technological projects from Houston, London, Barcelona and Andorra.",
      keywords: "Negolan, Technology, Innovation, Investment, Technology Projects, Houston, London, Barcelona, Andorra, Universal Tecno Services"
    },
    translationWarning: "This version is an AI translation and may contain errors. In case of doubt, the Spanish version prevails.",
    header: {
      about: "About Us",
      careers: "Work with Us",
      investors: "Investors",
      projects: "Projects",
      adminPanel: "Admin Panel",
      logout: "Logout",
      login: "Login",
      weLoveAndorra: "We ❤️ Andorra",
    },
    hero: {
      titlePre: "Always Looking for",
      titleInventors: "Inventors",
      titleAnd: "&",
      titleInvestors: "Investors",
      subtitle: "Innovation, exclusivity, and opportunity. Discover the technological projects defining the future from Houston, London, Barcelona, and Andorra.",
      buttonProjects: "View Projects",
      buttonJoin: "Join Us",
      buttonInvest: "I Want to Invest",
    },
    about: {
      title: "Our Mission",
      subtitle: "We connect vision with capital, and talent with opportunity.",
      card1Title: "About Negolan",
      card1Text: "Negolan is Universal Tecno Services' platform dedicated to incubating and accelerating disruptive technology projects. Our focus is twofold: on one hand, we offer an exclusive window for our partners and investors to closely follow the progress of our initiatives; on the other, we actively seek the brightest professionals to join our teams and help us build the future.",
      card2Title: "Universal Tecno Services",
      card2Text: "As the parent company, Universal Tecno Services provides the infrastructure, strategic support, and long-term vision. We believe in technology as an engine for change and progress. We operate globally from innovation hubs like Houston, London, Barcelona, and Andorra, driving solutions ranging from telecommunications to financial security and sustainable energy.",
    },
    careers: {
      title: "Work with Us",
      subtitle: "We are looking for innovative and passionate minds. Most of our roles are remote. Are you ready for the challenge?",
      applyNow: "Apply Now",
      noJobs: "There are currently no job openings available. Please check back later.",
    },
    investors: {
      title: "Investment Opportunities",
      subtitle: "At Negolan, we offer exclusive access to a portfolio of technology projects with high growth potential. We seek strategic partners who share our vision and wish to be part of the next generation of innovation.",
      listItem1: "Access to privileged information and detailed progress reports.",
      listItem2: "Diversification in cutting-edge sectors: Fintech, IoT, Energy, and Telecom.",
      listItem3: "Opportunities for co-investment and participation in funding rounds.",
      formTitle: "Contact our special team for investors",
      formName: "Full Name",
      formEmail: "Corporate Email",
      formCompany: "Company or Investment Fund",
      formMessage: "Your message (optional)",
      formButton: "Request Information",
      thankYouTitle: "Thank you for your interest",
      thankYouText: "Our investor relations team will contact you shortly.",
      thankYouButton: "Send another response",
    },
    footer: {
      copy: "Negolan - Universal Tecno Services. All rights reserved.",
      confidentiality: "Information about projects is confidential. Access and use are subject to a non-disclosure agreement.",
      legalNotice: "Legal Notice",
      privacyPolicy: "Privacy Policy",
      cookiesPolicy: "Cookies Policy",
      termsOfService: "Terms of Service",
      credits: "Created by LumInA Genesis and Genara Perez Toledo from Negolan.com",
      errorLinkPlaceholder: "Found an error on our website? Please tell us by clicking this link"
    },
    errorModal: {
      title: "Report an Error",
      name: "Name",
      email: "Email",
      description: "Explain the problem (max. 2000 characters)",
      submit: "Send report",
      subject: "Website error report - Negolan"
    },
    projectsModal: {
      title: "Our Projects",
      partnershipAvailable: "Partnership Available",
      confidentialDetails: "Confidential Details",
      progress: "Progress",
      confidentialInfoTitle: "Confidential Information",
      confidentialInfoText: "Log in to see the details.",
      loginButton: "Login",
    },
    loginModal: {
      title: "Project Access",
      subtitle: "Enter your credentials to continue.",
      emailPlaceholder: "Email",
      passwordPlaceholder: "Password",
      loginButton: "Login",
      termsPrefix: "By logging in, you agree to our",
      termsNDA: "non-disclosure agreement",
      termsAnd: "and",
      termsService: "terms of service",
      loginError: "Invalid login credentials. Please contact us via the WhatsApp Business button available on all our pages.",
    },
    clientArea: {
      welcome: "Hello,",
      subtitle: "Welcome to your exclusive area. Here you have access to the Negolan projects assigned to your account.",
      logout: "Log Out",
      confidentialDetails: "View Confidential Details",
      investmentOpportunity: "Investment Opportunity",
      noProjects: "You currently have no assigned projects.",
      supportTitle: "Need technical support?",
      supportText: "If you have questions about your projects or need technical help with the platform, our team is at your disposal.",
      supportButton: "Contact Support",
      guideButton: "Client Guide",
    },
    adminPanel: {
        title: "Admin Panel",
        closeButton: "Close Panel",
        navProjects: "Projects",
        navJobs: "Jobs",
        navInvestors: "Investors",
        navPartnerships: "Partnerships",
        manageProjectsTitle: "Manage Projects",
        addProjectButton: "Add Project",
        edit: "Edit",
        delete: "Delete",
        pause: "Pause",
        resume: "Resume",
        confirmDeleteProject: "Are you sure you want to delete this project?",
        projectFormEditTitle: "Edit Project",
        projectFormAddTitle: "Add Project",
        projectFormName: "Project Name (always in Spanish)",
        projectFormCityES: "City (ES)",
        projectFormCityEN: "City (EN)",
        projectFormAreaES: "Area (ES)",
        projectFormAreaEN: "Area (EN)",
        projectFormDescES: "Public Description (ES)",
        projectFormDescEN: "Public Description (EN)",
        projectFormIconURL: "Logo URL",
        projectFormPartnership: "Available for Partnership",
        cancel: "Cancel",
        save: "Save",
        manageJobsTitle: "Manage Jobs",
        addJobButton: "Add Job",
        confirmDeleteJob: "Are you sure you want to delete this job opening?",
        jobFormEditTitle: "Edit Job",
        jobFormAddTitle: "Add Job",
        jobFormTitleES: "Job Title (ES)",
        jobFormTitleEN: "Job Title (EN)",
        jobFormLocationES: "Location (ES)",
        jobFormLocationEN: "Location (EN)",
        jobFormTypeES: "Contract Type (ES)",
        jobFormTypeEN: "Contract Type (EN)",
        jobFormDescES: "Description (ES)",
        jobFormDescEN: "Description (EN)",
        investorLeadsTitle: "Investor Leads",
        addLeadButton: "Add Lead",
        noInvestorLeads: "There are no investor leads at the moment.",
        leadFormTitle: "Add Lead Manually",
        leadFormName: "Full Name",
        leadFormEmail: "Email",
        leadFormCompany: "Company (Optional)",
        leadFormMessage: "Message (Optional)",
        saveLeadButton: "Save Lead",
        partnershipLeadsTitle: "Partnership Leads",
        noPartnershipLeads: "There are no partnership leads at the moment.",
        interestProject: "Project of Interest",
        collaborationType: "Collaboration Type",
        budget: "Investment/Budget",
        companyDescription: "Company Description",
        detailedProposal: "Detailed Proposal",
        ndaAccepted: "NDA Accepted",
        yes: "Yes",
        no: "No",
    },
    maintenance: {
        title: "Site Under Maintenance",
        subtitle1: "We are performing important upgrades to our platform.",
        subtitle2: "We will be back online tomorrow. We apologize for the inconvenience.",
    },
    partnershipPage: {
        title: "Partnership Opportunities",
        intro: "At Negolan, we believe in the power of collaboration to drive innovation. We are looking for strategic partners who share our \"mischievous\" vision of technology and our desire to build groundbreaking AI solutions.",
        whatWeOfferTitle: "What does Negolan offer?",
        offer1: "Legal Infrastructure (Companies, Lawyers, Solicitors, Notaries, etc...) --> Everything needed to operate legally from countries beyond Spain.",
        offer2: "Technical Resources (Hosting, Domains, Servers, Know-How, Advanced Experience, Cloud, etc...) --> Everything needed to function technically.",
        offer3: "Accounting (International)",
        outro: "Basically, here it is explained in other words:",
        feature1Title: "1. Advanced Anti-Censorship Protection",
        feature1Text: "Digital escape network: automatic deployment of clones and mirrors in “safe harbor” countries, with instant DNS changes and backups if blocks occur. Early warning system: notifies clients of censorship or restricted access risks in any country. Integrated VPN or proxy for creators and companies, with smart routing.",
        feature2Title: "2. Shielded Digital Identity",
        feature2Text: "Creation and management of protected digital identities, including legal representation in “friendly” countries. Multi-country accounts to receive payments and operate with real legal security, not just Stripe's promise.",
        feature3Title: "3. Blockchain Certification and Timestamping",
        feature3Text: "Proof of authorship and existence for content, contracts, designs, ideas... “Digital notary” services with an immutable timestamp and verification on multiple public chains.",
        feature4Title: "4. Anti-Scam Defense and Auditing",
        feature4Text: "Auditing of projects and contracts (by AI and humans) to detect traps, abusive clauses, or scams. Collaborative blacklist and alert system for investors and developers.",
        feature5Title: "5. Secret Digital Vault",
        feature5Text: "Encrypted storage like a “digital safe” for critical documents, keys, backups... Recovery only through legal or delegated procedures (avoiding the typical “I lost my password and got ruined”).",
        feature6Title: "6. 24/7 Legal and Tax Assistance with AI + Humans",
        feature6Text: "Legal assistant trained in multiple jurisdictions, answering basic questions in real-time and escalating to a human only when necessary. Regulatory change alerts (imagine getting notified before they change tax law in Estonia or crypto regulations in Portugal!).",
        feature7Title: "7. Free Talent Marketplace",
        feature7Text: "A pool of developers and specialists “certified” by Negolan, who can also protect their work under smart contracts with guaranteed payment per milestone. “Express rescue” option: if a developer is in trouble, they can request mediation and direct protection (even physical).",
        feature8Title: "8. Shield Against Digital Harassment",
        feature8Text: "Anti-doxxing and threat defense: services to protect clients' identity and security when giants (or trolls) get aggressive. Immediate assistance to file complaints, delete exposed information, or neutralize reputational attacks.",
        feature9Title: "9. Ultra-Realistic Training",
        feature9Text: "Mini-courses and bootcamps for founders, investors, and developers: how to navigate the digital jungle, avoid fraud, optimize taxes, and use AI without it blowing up in your face. A testing lab to experiment with new technologies risk-free.",
        feature10Title: "10. Digital Reputation System",
        feature10Text: "Based on blockchain and validated by real clients, not reviews from buddies. Higher reputation leads to better conditions and access to premium resources.",
        feature11Title: "11. Personal Support and “Venting” Network",
        feature11Text: "Private spaces to share problems, scams suffered, harassment, failures... with guaranteed anonymity and the possibility of legal/psychological help.",
        feature12Title: "12. “Zero-Paperwork” Assisted Bureaucracy",
        feature12Text: "Automatic tools to file legal documents, claims, trademark/patent registrations, and international procedures... without breaking a sweat.",
        feature13Title: "13. “Legal Slap” AI",
        feature13Text: "An assistant that generates biting legal responses, based on each country's regulations, to reply to banks, multinationals, administrations, or any bully.",
        callToAction: "If you represent a company or are an investor with a bold idea looking for a technical team capable of bringing it to reality, you've come to the right place. We specialize in turning ambitious concepts into functional and disruptive products. Fill out the following form to start the conversation. We want to know all the details of your proposal.",
        formTitle: "Partnership Proposal Form",
        submittedTitle: "Proposal Sent Successfully",
        submittedText: "Thank you for your interest in collaborating. We have received your proposal and our team will review it carefully.",
        submittedSubtext: "We will contact you shortly.",
        backButton: "Back to the website",
        projectInterestLabel: "Project of Interest",
        collaborationTypeLabel: "Proposed Collaboration Type",
        collaborationTypePlaceholder: "Select a type...",
        collabOptionFinancial: "Financial Investment",
        collabOptionTech: "Technological",
        collabOptionMarketing: "Marketing and Sales",
        collabOptionStrategic: "Strategic Alliance",
        collabOptionRnD: "Research and Development",
        collabOptionOther: "Other",
        companyNameLabel: "Company/Organization Name",
        companyNamePlaceholder: "Your Company LLC",
        contactPersonLabel: "Contact Person's Name",
        contactPersonPlaceholder: "John Doe",
        emailLabel: "Contact Email",
        emailPlaceholder: "john.doe@yourcompany.com",
        countryLabel: "Country",
        sortBy: "Sort by:",
        sortByName: "Name",
        sortByCode: "Code",
        sortByPrefix: "Prefix",
        phoneLabel: "Phone Number (Optional)",
        phonePlaceholder: "123 456 789",
        websiteLabel: "Company Website (Optional)",
        websitePlaceholder: "https://yourcompany.com",
        companyDescLabel: "Brief Description of Your Company",
        companyDescPlaceholder: "Describe your company's main activity, size, and market.",
        proposalLabel: "Detailed Partnership Proposal",
        proposalPlaceholder: "Explain your idea, objectives, what you bring to the table, and what you expect from us. Be as detailed as possible.",
        budgetLabel: "Estimated Budget or Investment (Optional)",
        budgetPlaceholder: "E.g., '€50,000' or '20% equity stake'",
        securityQuestionLabel: "Security Question",
        securityQuestionText: "What is {num1} + {num2}?",
        securityAnswerPlaceholder: "Your answer",
        ndaLabel: "I agree that the information shared is confidential and I am willing to sign an NDA if necessary.",
        submitButton: "Send Proposal",
        alertIncorrectAnswer: "Incorrect security answer.",
        alertNdaRequired: "You must accept the non-disclosure agreement.",
    },
  },
  cat: {
    seo: {
      title: "Negolan - Innovació, Exclusivitat i Oportunitat",
      description: "Plataforma d'Universal Tecno Services dedicada a la incubació i acceleració de projectes tecnològics disruptius des de Houston, Londres, Barcelona i Andorra.",
      keywords: "Negolan, Tecnologia, Innovació, Inversió, Projectes Tecnològics, Houston, Londres, Barcelona, Andorra, Universal Tecno Services"
    },
    translationWarning: "Aquesta versió és una traducció per IA i pot contenir errors. En cas de dubte, preval la versió en espanyol.",
    header: {
      about: "Sobre Nosaltres",
      careers: "Treballa amb Nosaltres",
      investors: "Inversors",
      projects: "Projectes",
      adminPanel: "Tauler de Control",
      logout: "Tancar Sessió",
      login: "Accedir",
      weLoveAndorra: "We ❤️ Andorra",
    },
    hero: {
      titlePre: "Sempre Buscant",
      titleInventors: "Inventor@s",
      titleAnd: "i",
      titleInvestors: "Inversor@s",
      subtitle: "Innovació, exclusivitat i oportunitat. Descobreixi els projectes tecnològics que estan definint el futur des de Houston, Londres, Barcelona i Andorra.",
      buttonProjects: "Veure Projectes",
      buttonJoin: "Uneix-te a Nosaltres",
      buttonInvest: "Vull Invertir",
    },
    about: {
      title: "La Nostra Missió",
      subtitle: "Connectem visió amb capital, i talent amb oportunitat.",
      card1Title: "Sobre Negolan",
      card1Text: "Negolan és la plataforma d'Universal Tecno Services dedicada a la incubació i acceleració de projectes tecnològics disruptius. El nostre enfocament és dual: d'una banda, oferim una finestra exclusiva als nostres socis i inversors perquè segueixin de prop el progrés de les nostres iniciatives; de l'altra, busquem activament els professionals més brillants perquè s'uneixin als nostres equips i ens ajudin a construir el futur.",
      card2Title: "Universal Tecno Services",
      card2Text: "Com a empresa matriu, Universal Tecno Services proveeix la infraestructura, el suport estratègic i la visió a llarg termini. Creiem en la tecnologia com a motor de canvi i progrés. Operem globalment des de centres neuràlgics d'innovació com Houston, Londres, Barcelona i Andorra, impulsant solucions que abasten des de les telecomunicacions fins a la seguretat financera i l'energia sostenible.",
    },
    careers: {
      title: "Treballa amb Nosaltres",
      subtitle: "Busquem ments innovadores i apassionades. La majoria dels nostres rols són en remot. Estàs preparat per al repte?",
      applyNow: "Aplicar Ara",
      noJobs: "Actualment no hi ha ofertes de feina disponibles. Torna-ho a comprovar més endavant.",
    },
    investors: {
      title: "Oportunitats d'Inversió",
      subtitle: "A Negolan, oferim accés exclusiu a un portafoli de projectes tecnològics amb alt potencial de creixement. Busquem socis estratègics que comparteixin la nostra visió i vulguin formar part de la propera generació d'innovació.",
      listItem1: "Accés a informació privilegiada i informes de progrés detallats.",
      listItem2: "Diversificació en sectors d'avantguarda: Fintech, IoT, Energia i Telecom.",
      listItem3: "Oportunitats de co-inversió i participació en rondes de finançament.",
      formTitle: "Contacti amb el nostre equip especial per a inversors",
      formName: "Nom Complet",
      formEmail: "Email Corporatiu",
      formCompany: "Empresa o Fons d'Inversió",
      formMessage: "El seu missatge (opcional)",
      formButton: "Sol·licitar Informació",
      thankYouTitle: "Gràcies pel seu interès",
      thankYouText: "El nostre equip de relacions amb inversors es posarà en contacte amb vostè en breu.",
      thankYouButton: "Enviar una altra resposta",
    },
    footer: {
      copy: "Negolan - Universal Tecno Services. Tots els drets reservats.",
      confidentiality: "La informació sobre projectes és confidencial. L'accés i ús estan subjectes a un acord de confidencialitat.",
      legalNotice: "Avís Legal",
      privacyPolicy: "Política de Privacitat",
      cookiesPolicy: "Cookies",
      termsOfService: "Termes de Servei",
      credits: "Web creada per LumInA Genesis i Genara Perez Toledo de Negolan.com",
      errorLinkPlaceholder: "Has trobat algun error a la nostra web, per favor dis-nos-ho prement aquest link"
    },
    errorModal: {
      title: "Informar d'un error",
      name: "Nom",
      email: "Correu electrònic",
      description: "Expliqui el problema (màx. 2000 caràcters)",
      submit: "Enviar reportap",
      subject: "Report d'error a la web de Negolan"
    },
    projectsModal: {
      title: "Els nostres Projectes",
      partnershipAvailable: "Disponible Partnership",
      confidentialDetails: "Detalls Confidencials",
      progress: "Progrés",
      confidentialInfoTitle: "Informació Confidencial",
      confidentialInfoText: "Iniciï sessió per veure els detalls.",
      loginButton: "Accedir",
    },
    loginModal: {
      title: "Accés a Projectes",
      subtitle: "Introdueixi les seves credencials per continuar.",
      emailPlaceholder: "Email",
      passwordPlaceholder: "Contrasenya",
      loginButton: "Accedir",
      termsPrefix: "En accedir, vostè accepta el nostre",
      termsNDA: "acord de confidencialitat",
      termsAnd: "i els",
      termsService: "termes de servei",
      loginError: "Dades d'Accés Erronees. Contacti amb nosaltres a través del botó de Whatsapp Business que es troba a totes les nostres pàgines.",
    },
    adminPanel: {
        title: "Tauler de Control",
        closeButton: "Tancar Tauler",
        navProjects: "Projectes",
        navJobs: "Ocupació",
        navInvestors: "Inversors",
        navPartnerships: "Partnerships",
        manageProjectsTitle: "Gestionar Projectes",
        addProjectButton: "Afegir Projecte",
        edit: "Editar",
        delete: "Eliminar",
        pause: "Pausar",
        resume: "Reprendre",
        confirmDeleteProject: "Segur que vols eliminar aquest projecte?",
        projectFormEditTitle: "Editar Projecte",
        projectFormAddTitle: "Afegir Projecte",
        projectFormName: "Nom del Projecte (sempre en espanyol)",
        projectFormCityES: "Ciutat (ES)",
        projectFormCityEN: "Ciutat (EN)",
        projectFormAreaES: "Àrea (ES)",
        projectFormAreaEN: "Àrea (EN)",
        projectFormDescES: "Descripció Pública (ES)",
        projectFormDescEN: "Public Description (EN)",
        projectFormIconURL: "URL del Logo",
        projectFormPartnership: "Disponible per Partnership",
        cancel: "Cancel·lar",
        save: "Guardar",
        manageJobsTitle: "Gestionar Ofertes",
        addJobButton: "Afegir Oferta",
        confirmDeleteJob: "Segur que vols eliminar aquesta oferta de feina?",
        jobFormEditTitle: "Editar Oferta",
        jobFormAddTitle: "Afegir Oferta",
        jobFormTitleES: "Títol de l'oferta (ES)",
        jobFormTitleEN: "Job Title (EN)",
        jobFormLocationES: "Ubicació (ES)",
        jobFormLocationEN: "Location (EN)",
        jobFormTypeES: "Tipus de contracte (ES)",
        jobFormTypeEN: "Contract Type (EN)",
        jobFormDescES: "Descripció (ES)",
        jobFormDescEN: "Description (EN)",
        investorLeadsTitle: "Investor Leads",
        addLeadButton: "Afegir Lead",
        noInvestorLeads: "No hi ha leads d'inversors de moment.",
        leadFormTitle: "Afegir Lead Manualment",
        leadFormName: "Nom Complet",
        leadFormEmail: "Email",
        leadFormCompany: "Empresa (Opcional)",
        leadFormMessage: "Missatge (Opcional)",
        saveLeadButton: "Guardar Lead",
        partnershipLeadsTitle: "Leads de Partnership",
        noPartnershipLeads: "No hi ha leads de partnership de moment.",
        interestProject: "Projecte d'Interès",
        collaborationType: "Tipus de Col·laboració",
        budget: "Inversió/Pressupost",
        companyDescription: "Descripció de l'Empresa",
        detailedProposal: "Proposta Detallada",
        ndaAccepted: "NDA Acceptat",
        yes: "Sí",
        no: "No",
    },
    maintenance: {
        title: "Lloc en Manteniment",
        subtitle1: "Estem realitzant importants millores a la nostra plataforma.",
        subtitle2: "Tornarem a estar operatius demà. Disculpin les molèsties.",
    },
    partnershipPage: {
        title: "Oportunitats de Partnership",
        intro: "A Negolan, creiem en el poder de la col·laboració per impulsar la innovació. Estem buscant socis estratègics que comparteixin la nostra visió \"entremaliada\" de la tecnologia i el nostre desig de construir solucions d'IA que trenquin esquemes.",
        whatWeOfferTitle: "Què ofereix Negolan?",
        offer1: "Infraestructura Legal (Empreses, Advocats, Procuradors, Notaris, etc...) --> Tot el que fa falta per funcionar legalment des de països més enllà d'Espanya.",
        offer2: "Mitjans Tècnics (Hosting, Dominis, Servidors, Know-How, Experiència Elevada, Cloud, etc...) --> Tot el que fa falta per funcionar tècnicament.",
        offer3: "Comptabilitat (Internacional)",
        outro: "Bàsicament, aquí està explicat amb altres paraules:",
        feature1Title: "1. Protecció Anti-Censura Avançada",
        feature1Text: "Xarxa d'escapament digital: desplegament automàtic de clons i miralls en països “refugi”, amb canvi de DNS i còpia de seguretat instantània si hi ha bloquejos. Sistema d'alerta primerenca: notifica al client si hi ha risc de censura o accés restringit en algun país. VPN o intermediari integrat per a creadors i empreses, amb rutes intel·ligents.",
        feature2Title: "2. Identitat Digital Blindada",
        feature2Text: "Creació i gestió d'identitats digitals protegides, fins i tot amb representació legal en països “amics”. Comptes multi-país per rebre pagaments i operar amb seguretat jurídica real, no només la promesa d'Stripe.",
        feature3Title: "3. Certificació i Timestamping en Blockchain",
        feature3Text: "Prova d'autoria i existència per a continguts, contractes, dissenys, idees... Serveis de “digital notary” amb un segell de temps immutable i verificació en múltiples cadenes públiques.",
        feature4Title: "4. Defensa i Auditoria Anti-Estafes",
        feature4Text: "Auditoria de projectes i contractes (per IA i humans) per detectar trampes, clàusules abusives o estafes. Llista negra col·laborativa i sistema d'alertes per a inversors i programadors.",
        feature5Title: "5. Volta Digital Secreta",
        feature5Text: "Emmagatzematge xifrat tipus “caixa forta digital” per a documents, claus, còpies de seguretat crítiques... Recuperació només mitjançant procediments jurídics o delegats (evitant el típic “vaig perdre la contrasenya i em vaig arruïnar”).",
        feature6Title: "6. Assistència Legal i Fiscal 24/7 amb IA + Humans",
        feature6Text: "Assistent virtual jurídic entrenat en diverses jurisdiccions, que resol dubtes bàsics en temps real i deriva a un humà només si fa falta. Alerta de canvis normatius (imagina que t'avisi abans que canviïn la llei fiscal a Estònia o el règim de criptos a Portugal!).",
        feature7Title: "7. Mercat de Talent Lliure",
        feature7Text: "Una borsa de programadors i especialistes “certificats” per Negolan, que a més poden protegir el seu treball sota contractes intel·ligents amb pagament garantit per fita. Opció de “rescat exprés”: si un programador es veu en dificultats, pot sol·licitar mediació i protecció directa (fins i tot física).",
        feature8Title: "8. Escut contra l'Assetjament Digital",
        feature8Text: "Defensa anti doxxing i amenaces: serveis per protegir la identitat i la seguretat dels clients quan els gegants (o els trolls) es posen pesats. Assistència immediata per presentar denúncies, esborrar informació exposada, o neutralitzar atacs reputacionals.",
        feature9Title: "9. Formació Ultra-Realista",
        feature9Text: "Mini-cursos i bootcamps per a fundadors, inversors i programadors: com moure's per la jungla digital, esquivar fraus, optimitzar la fiscalitat i usar la IA sense que t'exploti a la cara. Laboratori de proves per experimentar amb tecnologies noves sense risc.",
        feature10Title: "10. Sistema de Reputació Digital",
        feature10Text: "Basat en blockchain i validat per clients reals, no ressenyes de col·legues. A major reputació, millors condicions i accés a recursos premium.",
        feature11Title: "11. Xarxa de Suport Personal i “Desfogament”",
        feature11Text: "Espais privats per compartir problemes, estafes patides, assetjaments, fracassos… amb anonimat garantit i possibilitat d'ajuda legal/psicològica.",
        feature12Title: "12. Burocràcia Assistida “Zero-papers”",
        feature12Text: "Eines automàtiques per presentar escrits legals, reclamacions, registres de marca/patent i tràmits internacionals… sense suar ni una gota.",
        feature13Title: "13. IA “Bufetada Legal”",
        feature13Text: "Assistent que genera respostes legals mordaços, basades en la normativa de cada país, per contestar a bancs, multinacionals, administracions o qualsevol abusananos.",
        callToAction: "Si representes una empresa o ets un inversor amb una idea audaç i busques un equip tècnic capaç de portar-la a la realitat, has arribat al lloc correcte. Ens especialitzem a convertir conceptes ambiciosos en productes funcionals i disruptius. Omple el següent formulari per iniciar la conversa. Volem conèixer tots els detalls de la teva proposta.",
        formTitle: "Formulari de Proposta de Partnership",
        submittedTitle: "Proposta Enviada amb Èxit",
        submittedText: "Gràcies pel teu interès a col·laborar. Hem rebut la teva proposta i el nostre equip la revisarà detingudament.",
        submittedSubtext: "Ens posarem en contacte amb tu en breu.",
        backButton: "Tornar a la web",
        projectInterestLabel: "Projecte d'Interès",
        collaborationTypeLabel: "Tipus de Col·laboració Proposada",
        collaborationTypePlaceholder: "Selecciona un tipus...",
        collabOptionFinancial: "Inversió Financera",
        collabOptionTech: "Tecnològica",
        collabOptionMarketing: "Màrqueting i Vendes",
        collabOptionStrategic: "Aliança Estratègica",
        collabOptionRnD: "Recerca i Desenvolupament",
        collabOptionOther: "Altra",
        companyNameLabel: "Nom de l'Empresa/Organització",
        companyNamePlaceholder: "La teva empresa S.L.",
        contactPersonLabel: "Nom de la Persona de Contacte",
        contactPersonPlaceholder: "Joan Pérez",
        emailLabel: "Email de Contacte",
        emailPlaceholder: "joan.perez@la-teva-empresa.com",
        countryLabel: "País",
        sortBy: "Ordenar per:",
        sortByName: "Nom",
        sortByCode: "Codi",
        sortByPrefix: "Prefix",
        phoneLabel: "Número de Telèfon (Opcional)",
        phonePlaceholder: "123 456 789",
        websiteLabel: "Lloc Web de l'Empresa (Opcional)",
        websitePlaceholder: "https://la-teva-empresa.com",
        companyDescLabel: "Breu Descripció de la teva Empresa",
        companyDescPlaceholder: "Descriu l'activitat principal, mida i mercat de la teva empresa.",
        proposalLabel: "Proposta Detallada de Partnership",
        proposalPlaceholder: "Explica la teva idea, els objectius, què aportes i què esperes de nosaltres. Sigues el més detallat possible.",
        budgetLabel: "Pressupost o Inversió Estimada (Opcional)",
        budgetPlaceholder: "Ex: '€50.000' o 'Participació del 20%'",
        securityQuestionLabel: "Pregunta de Seguretat",
        securityQuestionText: "Quant és {num1} + {num2}?",
        securityAnswerPlaceholder: "La teva resposta",
        ndaLabel: "Accepto que la informació compartida és confidencial i estic disposat/ada a signar un NDA si és necessari.",
        submitButton: "Enviar Proposta",
        alertIncorrectAnswer: "Resposta de seguretat incorrecta.",
        alertNdaRequired: "Ha d'acceptar l'acord de confidencialitat.",
    },
  },
  fr: {
    seo: {
      title: "Negolan - Innovation, Exclusivité et Opportunité",
      description: "Plateforme d'Universal Tecno Services dédiée à l'incubation et à l'accélération de projets technologiques disruptifs depuis Houston, Londres, Barcelone et Andorre.",
      keywords: "Negolan, Technologie, Innovation, Investissement, Projets Technologiques, Houston, Londres, Barcelone, Andorre, Universal Tecno Services"
    },
    translationWarning: "Cette version est une traduction par l'IA et peut contenir des erreurs. En cas de doute, la version espagnole l'emporte.",
    header: {
      about: "À Propos",
      careers: "Travailler avec Nous",
      investors: "Investisseurs",
      projects: "Projets",
      adminPanel: "Panneau de Contrôle",
      logout: "Déconnexion",
      login: "Connexion",
      weLoveAndorra: "We ❤️ Andorra",
    },
    hero: {
      titlePre: "Toujours à la Recherche",
      titleInventors: "Inventeurs",
      titleAnd: "et",
      titleInvestors: "Investisseurs",
      subtitle: "Innovation, exclusivité et opportunité. Découvrez les projets technologiques qui définissent l'avenir depuis Houston, Londres, Barcelone et Andorre.",
      buttonProjects: "Voir les Projets",
      buttonJoin: "Rejoignez-nous",
      buttonInvest: "Je Veux Investir",
    },
    about: {
      title: "Notre Mission",
      subtitle: "Nous connectons la vision au capital, et le talent à l'opportunité.",
      card1Title: "À Propos de Negolan",
      card1Text: "Negolan est la plateforme d'Universal Tecno Services dédiée à l'incubation et à l'accélération de projets technologiques disruptifs. Notre approche est double : d'une part, nous offrons une vitrine exclusive à nos partenaires et investisseurs pour suivre de près l'état d'avancement de nos initiatives ; d'autre part, nous recherchons activement les professionnels les plus brillants pour rejoindre nos équipes et nous aider à construire l'avenir.",
      card2Title: "Universal Tecno Services",
      card2Text: "En tant que société mère, Universal Tecno Services fournit l'infrastructure, le soutien stratégique et la vision à long terme. Nous croyons en la technologie comme moteur de changement et de progrès. Nous opérons mondialement depuis des centres névralgiques d'innovation tels que Houston, Londres, Barcelone et Andorre, en développant des solutions allant des télécommunications à la sécurité financière et à l'énergie durable.",
    },
    careers: {
      title: "Travailler avec Nous",
      subtitle: "Nous recherchons des esprits innovants et passionnés. La plupart de nos postes sont en télétravail. Êtes-vous prêt à relever le défi ?",
      applyNow: "Postuler Maintenant",
      noJobs: "Il n'y a actuellement aucune offre d'emploi disponible. Veuillez vérifier plus tard.",
    },
    investors: {
      title: "Opportunités d'Investissement",
      subtitle: "Chez Negolan, nous offrons un accès exclusif à un portefeuille de projets technologiques à fort potentiel de croissance. Nous recherchons des partenaires stratégiques qui partagent notre vision et souhaitent faire partie de la prochaine génération d'innovation.",
      listItem1: "Accès à des informations privilégiées et rapports d'avancement détaillés.",
      listItem2: "Diversification dans des secteurs de pointe : Fintech, IoT, Énergie et Télécoms.",
      listItem3: "Opportunités de co-investissement et participation à des levées de fonds.",
      formTitle: "Contactez notre équipe spéciale investisseurs",
      formName: "Nom Complet",
      formEmail: "Email Professionnel",
      formCompany: "Entreprise ou Fonds d'Investissement",
      formMessage: "Votre message (facultatif)",
      formButton: "Demander des Informations",
      thankYouTitle: "Merci pour votre intérêt",
      thankYouText: "Notre équipe des relations avec les investisseurs vous contactera sous peu.",
      thankYouButton: "Envoyer une autre réponse",
    },
    footer: {
      copy: "Negolan - Universal Tecno Services. Tous droits réservés.",
      confidentiality: "Les informations sur les projets sont confidentielles. L'accès et l'utilisation sont soumis à un accord de confidentialité.",
      legalNotice: "Mentions Légales",
      privacyPolicy: "Politique de Confidentialité",
      cookiesPolicy: "Cookies",
      termsOfService: "Conditions de Service",
      credits: "Site créé par LumInA Genesis et Genara Perez Toledo de Negolan.com",
      errorLinkPlaceholder: "Vous avez trouvé une erreur sur notre site, veuillez nous le dire en cliquant sur ce lien"
    },
    errorModal: {
      title: "Signaler une erreur",
      name: "Nom",
      email: "E-mail",
      description: "Expliquez le problème (max. 2000 caractères)",
      submit: "Envoyer le rapport",
      subject: "Rapport d'erreur sur le site Web de Negolan"
    },
    projectsModal: {
      title: "Nos Projets",
      partnershipAvailable: "Partenariat Disponible",
      confidentialDetails: "Détails Confidentiels",
      progress: "Progrès",
      confidentialInfoTitle: "Informations Confidentielles",
      confidentialInfoText: "Connectez-vous pour voir les détails.",
      loginButton: "Connexion",
    },
    loginModal: {
      title: "Accès aux Projets",
      subtitle: "Entrez vos identifiants pour continuer.",
      emailPlaceholder: "Email",
      passwordPlaceholder: "Mot de passe",
      loginButton: "Connexion",
      termsPrefix: "En vous connectant, vous acceptez notre",
      termsNDA: "accord de confidentialité",
      termsAnd: "et nos",
      termsService: "conditions de service",
      loginError: "Données d'accès invalides. Contactez-nous via le bouton WhatsApp Business disponible sur toutes nos pages.",
    },
    adminPanel: {
        title: "Panneau de Contrôle",
        closeButton: "Fermer le Panneau",
        navProjects: "Projets",
        navJobs: "Emplois",
        navInvestors: "Investisseurs",
        navPartnerships: "Partenariats",
        manageProjectsTitle: "Gérer les Projets",
        addProjectButton: "Ajouter un Projet",
        edit: "Modifier",
        delete: "Supprimer",
        pause: "Mettre en Pause",
        resume: "Reprendre",
        confirmDeleteProject: "Êtes-vous sûr de vouloir supprimer ce projet ?",
        projectFormEditTitle: "Modifier le Projet",
        projectFormAddTitle: "Ajouter un Projet",
        projectFormName: "Nom du Projet (toujours en espagnol)",
        projectFormCityES: "Ville (ES)",
        projectFormCityEN: "Ville (EN)",
        projectFormAreaES: "Secteur (ES)",
        projectFormAreaEN: "Secteur (EN)",
        projectFormDescES: "Description Publique (ES)",
        projectFormDescEN: "Description Publique (EN)",
        projectFormIconURL: "URL du Logo",
        projectFormPartnership: "Disponible pour Partenariat",
        cancel: "Annuler",
        save: "Enregistrer",
        manageJobsTitle: "Gérer les Emplois",
        addJobButton: "Ajouter une Offre",
        confirmDeleteJob: "Êtes-vous sûr de vouloir supprimer cette offre d'emploi ?",
        jobFormEditTitle: "Modifier l'Offre",
        jobFormAddTitle: "Ajouter une Offre",
        jobFormTitleES: "Titre de l'Offre (ES)",
        jobFormTitleEN: "Titre de l'Offre (EN)",
        jobFormLocationES: "Emplacement (ES)",
        jobFormLocationEN: "Emplacement (EN)",
        jobFormTypeES: "Type de contrat (ES)",
        jobFormTypeEN: "Type de contrat (EN)",
        jobFormDescES: "Description (ES)",
        jobFormDescEN: "Description (EN)",
        investorLeadsTitle: "Leads Investisseurs",
        addLeadButton: "Ajouter un Lead",
        noInvestorLeads: "Il n'y a actuellement aucun lead investisseur.",
        leadFormTitle: "Ajouter un Lead Manuellement",
        leadFormName: "Nom Complet",
        leadFormEmail: "Email",
        leadFormCompany: "Entreprise (Optionnel)",
        leadFormMessage: "Message (Optionnel)",
        saveLeadButton: "Enregistrer le Lead",
        partnershipLeadsTitle: "Leads Partenariats",
        noPartnershipLeads: "Il n'y a actuellement aucun lead partenariat.",
        interestProject: "Projet d'Intérêt",
        collaborationType: "Type de Collaboration",
        budget: "Investissement/Budget",
        companyDescription: "Description de l'Entreprise",
        detailedProposal: "Proposition Détaillée",
        ndaAccepted: "NDA Accepté",
        yes: "Oui",
        no: "Non",
    },
    maintenance: {
        title: "Site en Maintenance",
        subtitle1: "Nous effectuons des mises à jour importantes sur notre plateforme.",
        subtitle2: "Nous serons de retour demain. Veuillez nous excuser pour la gêne occasionnée.",
    },
    partnershipPage: {
        title: "Opportunités de Partenariat",
        intro: "Chez Negolan, nous croyons au pouvoir de la collaboration pour stimuler l'innovation. Nous recherchons des partenaires stratégiques qui partagent notre vision \"espiègle\" de la technologie et notre désir de construire des solutions d'IA avant-gardistes.",
        whatWeOfferTitle: "Que propose Negolan ?",
        offer1: "Infrastructure Légale (Sociétés, Avocats, Procureurs, Notaires, etc...) --> Tout ce qu'il faut pour fonctionner légalement depuis des pays au-delà de l'Espagne.",
        offer2: "Moyens Techniques (Hébergement, Domaines, Serveurs, Savoir-Faire, Expérience Élevée, Cloud, etc...) --> Tout ce qu'il faut pour fonctionner techniquement.",
        offer3: "Comptabilité (Internationale)",
        outro: "En gros, voici l'explication avec d'autres mots :",
        feature1Title: "1. Protection Avancée contre la Censure",
        feature1Text: "Réseau d'évasion numérique : déploiement automatique de clones et miroirs dans des pays “refuge”, avec changement de DNS et sauvegarde instantanée en cas de blocage.",
        feature2Title: "2. Identité Numérique Blindée",
        feature2Text: "Création et gestion d'identités numériques protégées, même avec une représentation légale dans les pays \"amis\".",
        feature3Title: "3. Certification et Horodatage Blockchain",
        feature3Text: "Preuve d'origine et existence pour le contenu, les contrats, la conception, les idées...",
        feature4Title: "4. Défense Anti-Arnaque et Audit",
        feature4Text: "Audit des projets et contrats (par IA et humains) pour détecter les pièges, clauses abusives, ou scams.",
        feature5Title: "5. Coffre-fort Numérique Secret",
        feature5Text: "Stockage crypté (coffre-fort digital) pour les documents critiques.",
        feature6Title: "6. Assistance Juridique et Fiscale 24/7 avec IA + Humains",
        feature6Text: "Assistant juridique formé dans diverses juridictions, résolvant les questions de base en temps réel.",
        feature7Title: "7. Marché de Talents Libre",
        feature7Text: "Un vivier de programmeurs certifiés par Negolan avec paiement garanti en contrats intelligents.",
        feature8Title: "8. Bouclier contre le Harcèlement Numérique",
        feature8Text: "Défense anti-doxxing et contre les menaces : services pour protéger l'identité et la sécurité.",
        feature9Title: "9. Formation Ultra-Réaliste",
        feature9Text: "Mini-cours et bootcamps pour fondateurs, investisseurs, et développeurs.",
        feature10Title: "10. Système de Réputation Numérique",
        feature10Text: "Basé sur la Blockchain et validé par de vrais clients.",
        feature11Title: "11. Réseau de Soutien Personnel",
        feature11Text: "Espaces privés pour partager des problèmes, escroqueries, harcèlement.",
        feature12Title: "12. Bureaucratie Assistée \"Zéro-Papier\"",
        feature12Text: "Outils automatisés pour les réclamations, l'enregistrement de brevets.",
        feature13Title: "13. IA \"Gifle Légale\"",
        feature13Text: "Assistant générant des réponses juridiques sévères basées sur la réglementation de chaque pays.",
        callToAction: "Si vous représentez une entreprise ou êtes un investisseur avec une idée audacieuse et recherchez une équipe technique, vous êtes au bon endroit. Remplissez le formulaire suivant pour commencer la conversation.",
        formTitle: "Formulaire de Proposition de Partenariat",
        submittedTitle: "Proposition Envoyée avec Succès",
        submittedText: "Merci de votre intérêt à collaborer. Notre équipe examinera attentivement votre proposition.",
        submittedSubtext: "Nous vous contacterons très prochainement.",
        backButton: "Retour au site",
        projectInterestLabel: "Projet d'Intérêt",
        collaborationTypeLabel: "Type de Collaboration Proposée",
        collaborationTypePlaceholder: "Sélectionnez un type...",
        collabOptionFinancial: "Investissement Financier",
        collabOptionTech: "Technologique",
        collabOptionMarketing: "Marketing et Ventes",
        collabOptionStrategic: "Alliance Stratégique",
        collabOptionRnD: "Recherche et Développement",
        collabOptionOther: "Autre",
        companyNameLabel: "Nom de l'Entreprise/Organisation",
        companyNamePlaceholder: "Votre entreprise SARL",
        contactPersonLabel: "Nom de la Personne de Contact",
        contactPersonPlaceholder: "Jean Dupont",
        emailLabel: "Email de Contact",
        emailPlaceholder: "jean.dupont@votre-entreprise.com",
        countryLabel: "Pays",
        sortBy: "Trier par:",
        sortByName: "Nom",
        sortByCode: "Code",
        sortByPrefix: "Préfixe",
        phoneLabel: "Numéro de Téléphone (Optionnel)",
        phonePlaceholder: "123 456 789",
        websiteLabel: "Site Web de l'Entreprise (Optionnel)",
        websitePlaceholder: "https://votre-entreprise.com",
        companyDescLabel: "Brève Description de votre Entreprise",
        companyDescPlaceholder: "Décrivez l'activité principale, la taille et le marché de votre entreprise.",
        proposalLabel: "Proposition Détaillée de Partenariat",
        proposalPlaceholder: "Expliquez votre idée, objectifs, ce que vous apportez et ce que vous attendez de nous.",
        budgetLabel: "Budget ou Investissement Estimé (Optionnel)",
        budgetPlaceholder: "Ex: '50 000 €' ou 'Participation de 20%'",
        securityQuestionLabel: "Question de Sécurité",
        securityQuestionText: "Combien font {num1} + {num2} ?",
        securityAnswerPlaceholder: "Votre réponse",
        ndaLabel: "J'accepte que les informations partagées soient confidentielles et je suis prêt(e) à signer un NDA si nécessaire.",
        submitButton: "Envoyer la Proposition",
        alertIncorrectAnswer: "Réponse de sécurité incorrecte.",
        alertNdaRequired: "Vous devez accepter l'accord de confidentialité.",
    },
  },
  ru: {
    seo: {
      title: "Negolan - Инновации, эксклюзивность и возможности",
      description: "Платформа Universal Tecno Services, посвященная инкубации и акселерации прорывных технологических проектов из Хьюстона, Лондона, Барселоны и Андорры.",
      keywords: "Negolan, Технологии, Инновации, Инвестиции, Технологические проекты, Хьюстон, Лондон, Барселона, Андорра, Universal Tecno Services"
    },
    translationWarning: "Эта версия является переводом ИИ и может содержать ошибки. В случае сомнений исходной считается версия на испанском языке.",
    header: {
      about: "О нас",
      careers: "Работа с нами",
      investors: "Инвесторам",
      projects: "Проекты",
      adminPanel: "Панель Управления",
      logout: "Выйти",
      login: "Войти",
      weLoveAndorra: "We ❤️ Andorra",
    },
    hero: {
      titlePre: "Всегда ищем",
      titleInventors: "Изобретателей",
      titleAnd: "и",
      titleInvestors: "Инвесторов",
      subtitle: "Инновации, эксклюзивность и возможности. Откройте для себя технологические проекты, определяющие будущее, из Хьюстона, Лондона, Барселоны и Андорры.",
      buttonProjects: "Посмотреть Проекты",
      buttonJoin: "Присоединяйтесь",
      buttonInvest: "Хочу Инвестировать",
    },
    about: {
      title: "Наша Миссия",
      subtitle: "Мы соединяем видение с капиталом, а талант с возможностями.",
      card1Title: "О Negolan",
      card1Text: "Negolan - это платформа Universal Tecno Services, созданная для инкубации и ускорения прорывных технологических проектов. Наш подход: мы предлагаем эксклюзивное окно нашим партнерам и инвесторам, а также активно ищем самых талантливых профессионалов для наших команд.",
      card2Title: "Universal Tecno Services",
      card2Text: "В качестве материнской компании Universal Tecno Services обеспечивает инфраструктуру, поддержку и долгосрочное видение. Мы работаем по всему миру из Хьюстона, Лондона, Барселоны и Андорры.",
    },
    careers: {
      title: "Работа с Нами",
      subtitle: "Мы ищем инновационные и страстные умы. Большинство наших ролей удаленные. Готовы ли вы к вызову?",
      applyNow: "Подать заявку сейчас",
      noJobs: "В настоящее время нет доступных вакансий. Пожалуйста, зайдите позже.",
    },
    investors: {
      title: "Инвестиционные возможности",
      subtitle: "Negolan предлагает эксклюзивный доступ к портфелю технологических проектов с высоким потенциалом.",
      listItem1: "Доступ к привилегированной информации и подробным отчетам.",
      listItem2: "Диверсификация: Fintech, IoT, Энергетика и Телеком.",
      listItem3: "Возможности совместного инвестирования.",
      formTitle: "Свяжитесь с нашей командой для инвесторов",
      formName: "Полное имя",
      formEmail: "Корпоративный Email",
      formCompany: "Компания или Фонд",
      formMessage: "Ваше сообщение (необязательно)",
      formButton: "Запросить информацию",
      thankYouTitle: "Спасибо за ваш интерес",
      thankYouText: "Наша команда скоро свяжется с вами.",
      thankYouButton: "Отправить еще один ответ",
    },
    footer: {
      copy: "Negolan - Universal Tecno Services. Все права защищены.",
      confidentiality: "Информация о проектах носит конфиденциальный характер.",
      legalNotice: "Юридическое уведомление",
      privacyPolicy: "Политика конфиденциальности",
      cookiesPolicy: "Файлы cookie",
      termsOfService: "Условия использования",
      credits: "Создано LumInA Genesis и Genara Perez Toledo из Negolan.com",
      errorLinkPlaceholder: "Нашли ошибку на сайте? Нажмите сюда, чтобы сообщить нам"
    },
    errorModal: {
      title: "Сообщить об ошибке",
      name: "Имя",
      email: "Электронная почта",
      description: "Опишите проблему",
      submit: "Отправить отчет",
      subject: "Отчет об ошибке на сайте Negolan"
    },
    projectsModal: {
      title: "Наши Проекты",
      partnershipAvailable: "Доступно Партнерство",
      confidentialDetails: "Конфиденциальные детали",
      progress: "Прогресс",
      confidentialInfoTitle: "Конфиденциальная информация",
      confidentialInfoText: "Войдите, чтобы увидеть подробности.",
      loginButton: "Войти",
    },
    loginModal: {
      title: "Доступ к проектам",
      subtitle: "Введите свои учетные данные.",
      emailPlaceholder: "Email",
      passwordPlaceholder: "Пароль",
      loginButton: "Войти",
      termsPrefix: "Входя в систему, вы соглашаетесь с",
      termsNDA: "соглашением о конфиденциальности",
      termsAnd: "и",
      termsService: "условиями обслуживания",
      loginError: "Неверные данные для входа.",
    },
    adminPanel: {
        title: "Панель Управления",
        closeButton: "Закрыть",
        navProjects: "Проекты",
        navJobs: "Вакансии",
        navInvestors: "Инвесторы",
        navPartnerships: "Партнерства",
        manageProjectsTitle: "Управление Проектами",
        addProjectButton: "Добавить Проект",
        edit: "Редактировать",
        delete: "Удалить",
        pause: "Пауза",
        resume: "Возобновить",
        confirmDeleteProject: "Уверены, что хотите удалить проект?",
        projectFormEditTitle: "Редактировать Проект",
        projectFormAddTitle: "Добавить Проект",
        projectFormName: "Имя (ES)",
        projectFormCityES: "Город (ES)",
        projectFormCityEN: "City (EN)",
        projectFormAreaES: "Область (ES)",
        projectFormAreaEN: "Area (EN)",
        projectFormDescES: "Описание (ES)",
        projectFormDescEN: "Description (EN)",
        projectFormIconURL: "URL Логотипа",
        projectFormPartnership: "Доступно для Партнерства",
        cancel: "Отмена",
        save: "Сохранить",
        manageJobsTitle: "Управление Вакансиями",
        addJobButton: "Добавить Вакансию",
        confirmDeleteJob: "Уверены, что хотите удалить вакансию?",
        jobFormEditTitle: "Редактировать Вакансию",
        jobFormAddTitle: "Добавить Вакансию",
        jobFormTitleES: "Название (ES)",
        jobFormTitleEN: "Job Title (EN)",
        jobFormLocationES: "Локация (ES)",
        jobFormLocationEN: "Location (EN)",
        jobFormTypeES: "Тип контракта (ES)",
        jobFormTypeEN: "Contract Type (EN)",
        jobFormDescES: "Описание (ES)",
        jobFormDescEN: "Description (EN)",
        investorLeadsTitle: "Лиды Инвесторов",
        addLeadButton: "Добавить Лид",
        noInvestorLeads: "Пока нет лидов инвесторов.",
        leadFormTitle: "Добавить Лид Вручную",
        leadFormName: "Имя",
        leadFormEmail: "Email",
        leadFormCompany: "Компания",
        leadFormMessage: "Сообщение",
        saveLeadButton: "Сохранить Лид",
        partnershipLeadsTitle: "Лиды Партнерств",
        noPartnershipLeads: "Пока нет лидов.",
        interestProject: "Проект",
        collaborationType: "Тип сотрудничества",
        budget: "Бюджет",
        companyDescription: "Описание компании",
        detailedProposal: "Детальное предложение",
        ndaAccepted: "NDA Принято",
        yes: "Да",
        no: "Нет",
    },
    maintenance: {
        title: "Сайт на реконструкции",
        subtitle1: "Мы проводим важные обновления нашей платформы.",
        subtitle2: "Мы вернемся завтра. Приносим извинения за неудобства.",
    },
    partnershipPage: {
        title: "Возможности Партнерства",
        intro: "В Negolan мы верим в силу сотрудничества. Мы ищем стратегов и новаторов.",
        whatWeOfferTitle: "Что предлагает Negolan?",
        offer1: "Юридическая Инфраструктура",
        offer2: "Технические Средства",
        offer3: "Бухгалтерия (Международная)",
        outro: "Краткое объяснение:",
        feature1Title: "1. Защита от Цензуры",
        feature1Text: "Цифровая сеть спасения и умная маршрутизация.",
        feature2Title: "2. Защищенная Цифровая Идентичность",
        feature2Text: "Мультинациональные аккаунты с правовой безопасностью.",
        feature3Title: "3. Сертификация Blockchain",
        feature3Text: "Доказательство авторства и смарт-контракты.",
        feature4Title: "4. Защита от Скама",
        feature4Text: "Аудит проектов и контрактов.",
        feature5Title: "5. Секретное Хранилище",
        feature5Text: "Зашифрованное хранилище для критических документов.",
        feature6Title: "6. Юридическая Помощь 24/7",
        feature6Text: "Ассистент юрист и уведомления об изменениях в законах.",
        feature7Title: "7. Биржа Талантов",
        feature7Text: "Защищенные смарт-контрактами программисты.",
        feature8Title: "8. Защита от Доксинга",
        feature8Text: "Отражение цифровых угроз и троллей.",
        feature9Title: "9. Ультра-Реалистичное Обучение",
        feature9Text: "Bootcamps для стартаперов.",
        feature10Title: "10. Цифровая Репутация",
        feature10Text: "Основано на блокчейне.",
        feature11Title: "11. Сеть Поддержки",
        feature11Text: "Частные пространства для решения проблем.",
        feature12Title: "12. Автоматическая Бюрократия",
        feature12Text: "Zero-paperwork интерфейсы.",
        feature13Title: "13. ИИ 'Юридическая пощечина'",
        feature13Text: "Генератор ответов на неправомерные действия.",
        callToAction: "Ищете команду? Вы по адресу.",
        formTitle: "Форма Партнерства",
        submittedTitle: "Отправлено",
        submittedText: "Спасибо за ваш интерес.",
        submittedSubtext: "Мы скоро свяжемся.",
        backButton: "Назад на сайт",
        projectInterestLabel: "Проект Интереса",
        collaborationTypeLabel: "Тип Сотрудничества",
        collaborationTypePlaceholder: "Выберите...",
        collabOptionFinancial: "Финансовые Инвестиции",
        collabOptionTech: "Технологическое",
        collabOptionMarketing: "Маркетинг",
        collabOptionStrategic: "Стратегический Альянс",
        collabOptionRnD: "R&D",
        collabOptionOther: "Другое",
        companyNameLabel: "Название Компании",
        companyNamePlaceholder: "Компания LLC",
        contactPersonLabel: "Контактное Лицо",
        contactPersonPlaceholder: "Иван Иванов",
        emailLabel: "Email",
        emailPlaceholder: "ivan@company.ru",
        countryLabel: "Страна",
        sortBy: "Сортировка:",
        sortByName: "Имя",
        sortByCode: "Код",
        sortByPrefix: "Префикс",
        phoneLabel: "Телефон (Необязательно)",
        phonePlaceholder: "123 456 789",
        websiteLabel: "Сайт (Необязательно)",
        websitePlaceholder: "https://yourcompany.com",
        companyDescLabel: "Описание Вашей Компании",
        companyDescPlaceholder: "Размер, рынок и прочее.",
        proposalLabel: "Детальное Предложение",
        proposalPlaceholder: "Цели, ожидания и вклад.",
        budgetLabel: "Бюджет (Необязательно)",
        budgetPlaceholder: "Например: '50,000 евро'",
        securityQuestionLabel: "Вопрос безопасности",
        securityQuestionText: "Сколько будет {num1} + {num2}?",
        securityAnswerPlaceholder: "Ваш ответ",
        ndaLabel: "Я согласен(на) подписать NDA.",
        submitButton: "Отправить Предложение",
        alertIncorrectAnswer: "Неправильный ответ.",
        alertNdaRequired: "Необходимо принять NDA.",
    },
  },
  ua: {
    seo: {
      title: "Negolan - Інновації, ексклюзивність та можливості",
      description: "Платформа Universal Tecno Services, присвячена інкубації та акселерації проривних технологічних проєктів з Х'юстона, Лондона, Барселони та Андорри.",
      keywords: "Negolan, Технології, Інновації, Інвестиції, Технологічні проєкти, Х'юстон, Лондон, Барселона, Андорра, Universal Tecno Services"
    },
    translationWarning: "Ця версія є перекладом ШІ та може містити помилки. У разі сумнівів перевага надається іспаномовній версії.",
    header: {
      about: "Про нас",
      careers: "Команда",
      investors: "Інвесторам",
      projects: "Проєкти",
      adminPanel: "Панель Керування",
      logout: "Вийти",
      login: "Увійти",
      weLoveAndorra: "We ❤️ Andorra",
    },
    hero: {
      titlePre: "Завжди шукаємо",
      titleInventors: "Винахідників",
      titleAnd: "та",
      titleInvestors: "Інвесторів",
      subtitle: "Інновації, ексклюзивність та можливості. Відкрийте для себе технологічні проєкти майбутнього з Х'юстона, Лондона, Барселони та Андорри.",
      buttonProjects: "Переглянути Проєкти",
      buttonJoin: "Приєднатися",
      buttonInvest: "Хочу Інвестувати",
    },
    about: {
      title: "Наша Місія",
      subtitle: "Ми єднаємо бачення з капіталом, а талант з можливостями.",
      card1Title: "Про Negolan",
      card1Text: "Negolan - це платформа Universal Tecno Services, створена для підтримки та розвитку проривних технологічних проєктів. Ми пропонуємо ексклюзивний доступ для наших партнерів та активно шукаємо таланти.",
      card2Title: "Universal Tecno Services",
      card2Text: "Як материнська компанія, Universal Tecno Services забезпечує інфраструктуру, підтримку та довгострокове бачення. Ми працюємо по всьому світу з центрів інновацій: Х'юстона, Лондона, Барселони та Андорри.",
    },
    careers: {
      title: "Працюйте з нами",
      subtitle: "Ми шукаємо інноваційні уми. Більшість вакансій віддалені. Чи готові ви до виклику?",
      applyNow: "Подати заявку",
      noJobs: "Наразі немає відкритих вакансій.",
    },
    investors: {
      title: "Інвестиційні Можливості",
      subtitle: "Negolan пропонує ексклюзивний доступ до портфеля технологічних проєктів.",
      listItem1: "Доступ до конфіденційної інформації та детальних звітів.",
      listItem2: "Диверсифікація у передові сектори: Fintech, IoT, Енергетика.",
      listItem3: "Можливості спільного інвестування.",
      formTitle: "Зв'яжіться з нашою командою для інвесторів",
      formName: "Повне ім'я",
      formEmail: "Корпоративний Email",
      formCompany: "Компанія чи Фонд",
      formMessage: "Ваше повідомлення",
      formButton: "Запитати інформацію",
      thankYouTitle: "Дякуємо за ваш інтерес",
      thankYouText: "Наша команда скоро з вами зв'яжеться.",
      thankYouButton: "Надіслати ще одну відповідь",
    },
    footer: {
      copy: "Negolan - Universal Tecno Services. Всі права захищені.",
      confidentiality: "Інформація про проєкти конфіденційна.",
      legalNotice: "Правова інформація",
      privacyPolicy: "Політика Конфіденційності",
      cookiesPolicy: "Файли Cookies",
      termsOfService: "Умови Надання Послуг",
      credits: "Створено LumInA Genesis та Genara Perez Toledo з Negolan.com",
      errorLinkPlaceholder: "Знайшли помилку на сайті? Натисніть тут"
    },
    errorModal: {
      title: "Повідомити про помилку",
      name: "Ім'я",
      email: "Електронна пошта",
      description: "Опишіть проблему",
      submit: "Надіслати",
      subject: "Повідомлення про помилку на сайті Negolan"
    },
    projectsModal: {
      title: "Наші Проєкти",
      partnershipAvailable: "Доступне Партнерство",
      confidentialDetails: "Конфіденційні деталі",
      progress: "Прогрес",
      confidentialInfoTitle: "Конфіденційна Інформація",
      confidentialInfoText: "Увійдіть для перегляду.",
      loginButton: "Увійти",
    },
    loginModal: {
      title: "Доступ до Проєктів",
      subtitle: "Введіть свої облікові дані.",
      emailPlaceholder: "Email",
      passwordPlaceholder: "Пароль",
      loginButton: "Увійти",
      termsPrefix: "Увішовши, ви погоджуєтесь з",
      termsNDA: "угодою про конфіденційність",
      termsAnd: "та",
      termsService: "умовами надання послуг",
      loginError: "Помилка входу.",
    },
    adminPanel: {
        title: "Панель Керування",
        closeButton: "Закрити",
        navProjects: "Проєкти",
        navJobs: "Вакансії",
        navInvestors: "Інвестори",
        navPartnerships: "Партнерства",
        manageProjectsTitle: "Управління Проєктами",
        addProjectButton: "Додати Проєкт",
        edit: "Редагувати",
        delete: "Видалити",
        pause: "Пауза",
        resume: "Відновити",
        confirmDeleteProject: "Дійсно видалити?",
        projectFormEditTitle: "Редагувати",
        projectFormAddTitle: "Додати",
        projectFormName: "Ім'я",
        projectFormCityES: "Місто (ES)",
        projectFormCityEN: "Місто (EN)",
        projectFormAreaES: "Сектор (ES)",
        projectFormAreaEN: "Сектор (EN)",
        projectFormDescES: "Опис (ES)",
        projectFormDescEN: "Опис (EN)",
        projectFormIconURL: "URL Логотипу",
        projectFormPartnership: "Доступно для Партнерства",
        cancel: "Скасувати",
        save: "Зберегти",
        manageJobsTitle: "Вакансії",
        addJobButton: "Додати",
        confirmDeleteJob: "Дійсно видалити?",
        jobFormEditTitle: "Редагувати",
        jobFormAddTitle: "Додати",
        jobFormTitleES: "Назва (ES)",
        jobFormTitleEN: "Назва (EN)",
        jobFormLocationES: "Локація (ES)",
        jobFormLocationEN: "Локація (EN)",
        jobFormTypeES: "Тип (ES)",
        jobFormTypeEN: "Тип (EN)",
        jobFormDescES: "Опис (ES)",
        jobFormDescEN: "Опис (EN)",
        investorLeadsTitle: "Ліди",
        addLeadButton: "Додати",
        noInvestorLeads: "Немає лідів.",
        leadFormTitle: "Додати Лід",
        leadFormName: "Ім'я",
        leadFormEmail: "Email",
        leadFormCompany: "Компанія",
        leadFormMessage: "Повідомлення",
        saveLeadButton: "Зберегти",
        partnershipLeadsTitle: "Ліди Партнерств",
        noPartnershipLeads: "Немає лідів.",
        interestProject: "Проєкт",
        collaborationType: "Тип співпраці",
        budget: "Бюджет",
        companyDescription: "Опис компанії",
        detailedProposal: "Пропозиція",
        ndaAccepted: "NDA прийнято",
        yes: "Так",
        no: "Ні",
    },
    maintenance: {
        title: "Сайт на реконструкції",
        subtitle1: "Ми проводимо важливі оновлення.",
        subtitle2: "Повернемося завтра. Вибачте за незручності.",
    },
    partnershipPage: {
        title: "Можливості Партнерства",
        intro: "Ми віримо в силу співпраці.",
        whatWeOfferTitle: "Що пропонує Negolan?",
        offer1: "Юридична Інфраструктура",
        offer2: "Технічні Засоби",
        offer3: "Міжнародна бухгалтерія",
        outro: "Основне:",
        feature1Title: "1. Захист від Цензури",
        feature1Text: "Резервні мережі та VPN.",
        feature2Title: "2. Цифрова Ідентичність",
        feature2Text: "Захищені акаунти.",
        feature3Title: "3. Blockchain Сертифікація",
        feature3Text: "Захист авторства.",
        feature4Title: "4. Захист від Скаму",
        feature4Text: "Аудит за допомогою ШІ.",
        feature5Title: "5. Секретне Сховище",
        feature5Text: "Зашифровані дані.",
        feature6Title: "6. Юридична Допомога 24/7",
        feature6Text: "Ассистент юрист.",
        feature7Title: "7. Біржа Талантів",
        feature7Text: "Захищені смарт-контрактами фахівці.",
        feature8Title: "8. Захист від Доксінгу",
        feature8Text: "Безпека ідентичності.",
        feature9Title: "9. Навчання",
        feature9Text: "Курси та буткемпи.",
        feature10Title: "10. Цифрова Репутація",
        feature10Text: "Blockchain репутація.",
        feature11Title: "11. Мережа Підтримки",
        feature11Text: "Приватні простори.",
        feature12Title: "12. Автоматична Бюрократія",
        feature12Text: "Без паперів.",
        feature13Title: "13. ШІ 'Юридичний захист'",
        feature13Text: "Юридичні відповіді.",
        callToAction: "Маєте ідею? Напишіть нам.",
        formTitle: "Форма Пропозиції",
        submittedTitle: "Віправлено",
        submittedText: "Дякуємо.",
        submittedSubtext: "Ми зв'яжемося незабаром.",
        backButton: "Повернутися",
        projectInterestLabel: "Проєкт Інтересу",
        collaborationTypeLabel: "Тип Співпраці",
        collaborationTypePlaceholder: "Оберіть...",
        collabOptionFinancial: "Фінансові Інвестиції",
        collabOptionTech: "Технологічне",
        collabOptionMarketing: "Маркетинг",
        collabOptionStrategic: "Стратегічний Альянс",
        collabOptionRnD: "R&D",
        collabOptionOther: "Інше",
        companyNameLabel: "Назва Компанії",
        companyNamePlaceholder: "Компанія",
        contactPersonLabel: "Контактна Особа",
        contactPersonPlaceholder: "Іван Іванов",
        emailLabel: "Email",
        emailPlaceholder: "email@email.com",
        countryLabel: "Країна",
        sortBy: "Сортувати:",
        sortByName: "Ім'я",
        sortByCode: "Код",
        sortByPrefix: "Префікс",
        phoneLabel: "Телефон (Необов'язково)",
        phonePlaceholder: "123",
        websiteLabel: "Сайт (Необов'язково)",
        websitePlaceholder: "https://",
        companyDescLabel: "Опис Компанії",
        companyDescPlaceholder: "Рік заснування, ринок.",
        proposalLabel: "Пропозиція",
        proposalPlaceholder: "Ваша ідея.",
        budgetLabel: "Бюджет (Необов'язково)",
        budgetPlaceholder: "Напр. 50 000 євро",
        securityQuestionLabel: "Питання безпеки",
        securityQuestionText: "Скільки буде {num1} + {num2}?",
        securityAnswerPlaceholder: "Відповідь",
        ndaLabel: "Готовий підписати NDA.",
        submitButton: "Надіслати",
        alertIncorrectAnswer: "Невірна відповідь.",
        alertNdaRequired: "Необхідно прийняти NDA.",
    },
  }
};
